const CARD_THEME_KEYS = new Set(['core-two', 'solutions', 'partimus']);

export function getCardThemeKey(branding) {
  return CARD_THEME_KEYS.has(branding?.key) ? branding.key : null;
}
